//Componentes generales
import React, { useState, useEffect } from "react";
import moment from "moment";

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from "../../utils/priority";

//Permisos
import {
  EDITAR_NOTAS_PRIVADAS_REQ,
  VISUALIZA_ULTIMO_PRECIO_COMPRA,
} from "../../utils/permisos";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faBox,
  faRotateRight,
  faFilePdf,
  faDownload,
  faPen,
  faRectangleXmark,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";

//Estilos
import "./ReqInfo.css";

/* 
    Componente encargado de mostrar el detalle del requerimiento.
      Donde item es el requerimiento seleccionado.
      files son los archivos adjuntados al requerimiento.
      cerrar es la función encargada de ocultar el dialogo.
      verDetalle es la función del context que recupera los productos del requerimiento.
      repetir es una función que llama al componente que corresponda.
      generaPDF es una función que llama al componente que corresponda.
      abrirURL es la función encargada de abrir en una nueva ventana el archivo seleccionado.
      guardarModificaciones es la función del context que guarda el requerimiento en el caso de haber modificaciones.
      usuario es el usuario en sesión.

*/
function ReqInfo({
  item = {},
  files,
  cerrar,
  verDetalle,
  repetir,
  generaPDF,
  abrirURL,
  guardarModificaciones,
  usuario,
  checkPermisos,
}) {
  //state de productos.
  const [products, setProducts] = useState([]);
  //state de requerimiento.
  const [requerimiento, setRequerimiento] = useState(item);
  //state para edición de nota.
  const [editNota, setEditNota] = useState(false);
  //state para edición de nota privada.
  const [editNotaReservada, setEditNotaReservada] = useState(false);
  //state para edición de prioridad.
  const [editPrioridad, setEditPrioridad] = useState(false);
  //Permiso para visualizar último precio de compra de cada producto
  const [visualizaPrecioProduct, setVisualizaPrecioProduct] = useState(false);

  //state para indicar nota ya editada.
  //const [editadoNota, setEditadoNota] = useState(false);
  //state para indicar nota reservada ya editada.
  //const [editadoNotaReservada, setEditadoNotaReservada] = useState(false);

  /*
      Al renderizar el componente, recupera los productos del requerimiento seleccionado.
  */

  useEffect(() => {
    async function fp() {
      try {
        const p = await verDetalle(item.tDocCodFor, item.tDocNroFor);
        setProducts(p);
      } catch (error) {
        console.log("error");
      }
    }
    fp();
  }, []);

  useEffect(() => {
    setVisualizaPrecioProduct(
      usuario.userType.some((item) =>
        VISUALIZA_ULTIMO_PRECIO_COMPRA.includes(item.typeName)
      )
    );
  }, [usuario]);

  /*
      Disparador que se activa al detectar algun cambio en el item. Setea el requerimiento con el item que fue modificado.
  */
  useEffect(() => {
    setRequerimiento(item);
  }, [item]);

  /*
      Manejador que descargar/abre todos los archivos adjuntados al requerimiento. 
  */
  const handleDownloadAll = () => {
    files.map((file) => abrirURL(file.url));
  };

  /* 
      Manejador que determina si habilitar o no la edición del campo Nota.
  */
  const handleEditNota = () => {
    setEditNota(!editNota);
  };

  /* 
      Manejador que determina si habilitar o no la edición del campo Nota Reservada.
  */
  const handleEditNotaReservada = () => {
    setEditNotaReservada(!editNotaReservada);
  };

  /* 
      Manejador que determina si habilitar o no la edición de la prioridad.
  */
  const handleEditPrioridad = () => {
    setEditPrioridad(!editPrioridad);
  };

  /* 
      Manejador ante cambio en casilla de Nota.
      Donde valor es lo ingresado por el usuario.
  */
  const handleModificaNota = (valor) => {
    setRequerimiento({ ...requerimiento, notePubl: valor });
    //setEditadoNota(true);
  };

  /* 
      Manejador ante cambio en casilla de Nota Reservada.
      Donde valor es lo ingresado por el usuario.
  */
  const handleModificaNotaReservada = (valor) => {
    setRequerimiento({ ...requerimiento, notePriv: valor });
    //setEditadoNotaReservada(true);
  };

  /* 
        Manejador ante cambio en la prioridad.
        Donde valor es lo seleccionado por el usuario.
  */
  const handleModificaPrioridad = async (valor) => {
    const req_temp = { ...requerimiento, priority: valor };
    setEditPrioridad(false);
    setEditNotaReservada(false);
    setEditNota(false);
    const resp = await guardarModificaciones(req_temp, { priority: valor });

    setRequerimiento(resp.data);
  };

  /* 
      Guarda el requerimiento mediante función del context.
  */
  const saveChangesNota = async (valor) => {
    setEditNota(false);
    setEditPrioridad(false);

    const obj = { notePubl: requerimiento.notePubl };
    const resp = await guardarModificaciones(requerimiento, obj);
    setRequerimiento(resp.data);
  };

  const saveChangesNotaReservada = async (valor) => {
    setEditNotaReservada(false);
    setEditPrioridad(false);

    const obj = { notePriv: requerimiento.notePriv };
    const resp = await guardarModificaciones(requerimiento, obj);
    setRequerimiento(resp.data);
  };

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <div className="container-gr-req">
      <div>
        <div className="container-r-list-item-header-info">
          <div className="label-req">
            {requerimiento.tDocCodFor + " - " + requerimiento.tDocNroFor}
          </div>
          <div className="r-list-item-header-title">{requerimiento.title}</div>
          {/* <div className={requerimiento.priority === 0 ? 'r-list-item-header-priority-media margin-right-r' : requerimiento.priority === 1 ? 'r-list-item-header-priority-alta margin-right-r' : 'r-list-item-header-priority-urgente margin-right-r'}>{PRIORITYOUT[requerimiento.priority]}</div> */}
          <div className="container-prioritys-gral">
            <div
              className={
                requerimiento.priority === 2
                  ? "r-list-item-header-priority-urgente  margin-right-r"
                  : requerimiento.priority === 1
                  ? "r-list-item-header-priority-alta  margin-right-r"
                  : "r-list-item-header-priority-media  margin-right-r"
              }
              onClick={handleEditPrioridad}
            >
              {PRIORITY[requerimiento.priority ? requerimiento.priority : 0]}
            </div>
            {editPrioridad && (
              <div className="options-container-reqinfo">
                <div className="options-container-fr-back">
                  {PRIORITY.map((prior) => {
                    return (
                      <div
                        key={prior}
                        className={
                          PRIORITYIN[prior] === 2
                            ? "r-list-item-header-priority-urgente"
                            : PRIORITYIN[prior] === 1
                            ? "r-list-item-header-priority-alta"
                            : "r-list-item-header-priority-media"
                        }
                        value={prior}
                        onClick={() =>
                          handleModificaPrioridad(PRIORITYIN[prior])
                        }
                      >
                        {prior}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <FontAwesomeIcon
            style={{ cursor: "pointer" }}
            icon={faXmark}
            onClick={() => cerrar(null)}
          />
        </div>
      </div>
      <div className="container-r-item-details">
        <div className="container-r-info-p">
          <div className="label-value-pair">
            <div className="label-req-title">Estado Actual:</div>
            <div className="r-list-item-details-clave-v">
              {requerimiento.state}
            </div>

            <div className="label-req-title">Usuario:</div>
            <div className="r-list-item-details-clave-v">
              {requerimiento.userName}
            </div>
          </div>

          <div className="label-value-pair">
            <div className="label-req-title">Depósito:</div>
            <div className="r-list-item-details-title-v">
              {requerimiento.tDocAbmWarehouseDeposi} (
              {requerimiento.tDocAbmWarehouseDescrp})
            </div>

            <div className="label-req-title">Sector del Depósito:</div>
            <div className="r-list-item-details-title-v">
              {requerimiento.tDocAbmWarehouseSectorSector} (
              {requerimiento.tDocAbmWarehouseSectorDescrp})
            </div>
          </div>

        <div className="label-value-pair">
            <div className="label-req-title">Sector de Requerimiento:</div>
            <div className="r-list-item-details-title-v">
              {requerimiento.tDocAbmReqSectorCodsem} (
              {requerimiento.tDocAbmReqSectorDescrp})
            </div>
          </div>
        </div>

        <div className="container-r-item-title-details">Info Adicional</div>
        <div className="container-r-texto">
          <div className="r-list-item-details-data-v">
            {requerimiento.observ}
          </div>
        </div>
        <div className="container-r-item-title-details">Fecha</div>
        <div className="container-r-fecha">
          <div className="label-req-fecha">
            <div className="r-list-item-details-data-v">Alta </div>
            <div className="r-list-item-details-fecha-v">
              {moment.utc(requerimiento.fecAlt).format("DD-MM-YYYY")}
            </div>
          </div>
          <div className="label-req-fecha">
            <div className="r-list-item-details-data-v">Movimiento </div>
            <div className="r-list-item-details-fecha-v">
              {moment.utc(requerimiento.fchMov).format("DD-MM-YYYY")}
            </div>
          </div>
          <div className="label-req-fecha">
            <div className="r-list-item-details-data-v">Entrega </div>
            <div className="r-list-item-details-fecha-v">
              {moment.utc(requerimiento.deliveryDate).format("DD-MM-YYYY")}
            </div>
          </div>
        </div>
        <>
          <div className="container-r-item-title-details">
            Items: {requerimiento.quantity}
          </div>
          <div className="container-list-products-r-gral">
            {products.map((product) => {
              return (
                <div className="container-list-products-r" key={product.codRed}>
                  <div className="container-list-product-r-icon">
                    <div className="list-item-icon-r">
                      <FontAwesomeIcon icon={faBox} />
                    </div>
                    {product.codRed && (
                      <div className="list-item-title-r">{product.codRed}</div>
                    )}
                  </div>
                  <div className="container-list-products-r-details">
                    <div className="container-product-info-descrp">
                      <div>{product.descrp}</div>
                      <div>{product.textAdic}</div>
                    </div>
                    <div className="container-product-info">
                      <div className="container-cantidad-product-r">
                        <span class="text-decorator">Cantidad</span>:{" "}
                        {product.quantity}
                      </div>
                      <>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {checkPermisos(VISUALIZA_ULTIMO_PRECIO_COMPRA) && (
                          <div className="container-cantidad-product-r">
                            <span class="text-decorator">
                              Costo de última compra
                            </span>
                            : USD{" "}
                            {formatter.format(
                              product.price ? product.price : 0
                            )}
                          </div>
                        )}
                        <>
                          <div className="container-cantidad-product-r">
                            <span class="text-decorator">Tipo de costo</span>:{" "}
                            {product.tipoCosto.abmSubCue} -{" "}
                            {product.tipoCosto.abmSubCueDescrp}{" "}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </div>

                          <div className="container-cantidad-product-r">
                            <span class="text-decorator">Centro de costo</span>:{" "}
                            {product.centroCosto.abmSubCue} -{" "}
                            {product.centroCosto.abmSubCueDescrp}
                          </div>
                        </>
                      </>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
        <div className="container-r-item-title-details">
          <div>Nota</div>
          {!editNota && (
            <div className="container-button-download">
              {!editNotaReservada && (
                <button className="button-edit" onClick={handleEditNota}>
                  <FontAwesomeIcon icon={faPen} />{" "}
                </button>
              )}
            </div>
          )}
          {editNota && (
            <div className="container-button-download">
              <button className="button-edit" onClick={handleEditNota}>
                <FontAwesomeIcon icon={faRectangleXmark} />
              </button>
              <button className="button-edit" onClick={saveChangesNota}>
                <FontAwesomeIcon icon={faFloppyDisk} />
              </button>
            </div>
          )}
        </div>
        <div className="container-r-texto">
          {!editNota && (
            <div className="r-list-item-details-data-v">
              {requerimiento.notePubl}
            </div>
          )}
          {editNota && (
            <textarea
              className="r-textarea-input"
              value={requerimiento.notePubl}
              onChange={(data) => handleModificaNota(data.target.value)}
            />
          )}
        </div>
        {usuario.userType.some((item) =>
          EDITAR_NOTAS_PRIVADAS_REQ.includes(item.typeName)
        ) && (
          <>
            <div className="container-r-item-title-details">
              <div>Nota Reservada</div>
              {!editNotaReservada && (
                <div className="container-button-download">
                  {!editNota && (
                    <button
                      className="button-edit"
                      onClick={handleEditNotaReservada}
                    >
                      <FontAwesomeIcon icon={faPen} />{" "}
                    </button>
                  )}
                </div>
              )}
              {editNotaReservada && (
                <div className="container-button-download">
                  <button
                    className="button-edit"
                    onClick={handleEditNotaReservada}
                  >
                    <FontAwesomeIcon icon={faRectangleXmark} />
                  </button>
                  <button
                    className="button-edit"
                    onClick={saveChangesNotaReservada}
                  >
                    <FontAwesomeIcon icon={faFloppyDisk} />
                  </button>
                </div>
              )}
            </div>
            <div className="container-r-texto">
              {!editNotaReservada && (
                <div className="r-list-item-details-data-v">
                  {requerimiento.notePriv}
                </div>
              )}
              {editNotaReservada && (
                <textarea
                  className="r-textarea-input"
                  value={requerimiento.notePriv}
                  onChange={(data) =>
                    handleModificaNotaReservada(data.target.value)
                  }
                />
              )}
            </div>
          </>
        )}
        {files.length > 0 ? (
          <>
            <div className="container-r-item-title-details">
              <div>Archivos</div>
              <div className="container-button-download">
                <button className="button-download" onClick={handleDownloadAll}>
                  Descargar Todos <FontAwesomeIcon icon={faDownload} />{" "}
                </button>
              </div>
            </div>
            <div className="container-files-rq">
              <ul className="container-files-rq-details">
                {files.map((file) => (
                  <li
                    className="container-files-rq-details-items"
                    key={file.name}
                    onClick={() => abrirURL(file.url)}
                  >
                    {file.name}
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : null}
      </div>
      <div className="rq-container-buttons-bottom">
        <div
          className="rq-button-bottom button-pdf"
          onClick={() => generaPDF(requerimiento, visualizaPrecioProduct)}
        >
          <FontAwesomeIcon icon={faFilePdf} /> PDF
        </div>
        {requerimiento.tDocCodFor == "REQ" ? (
          <div
            className="rq-button-bottom button-repetir"
            onClick={() => repetir(requerimiento, products)}
          >
            <FontAwesomeIcon icon={faRotateRight} /> Repetir
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default ReqInfo;